import { api } from './http';

export function pinDialogMarkup(): string {
  return `<dialog class="pin-dialog" data-pin-dialog aria-labelledby="pinDialogTitle">
    <div class="pin-dialog-content">
      <button class="pin-dialog-close" type="button" data-pin-close aria-label="Close PIN dialog">×</button>
      <p class="eyebrow">Live survey data</p>
      <h2 id="pinDialogTitle">Enter the PIN</h2>
      <p>Enter the PIN to use non-smoke-test data.</p>
      <form class="stack-form" data-pin-form>
        <label>PIN<input name="pin" type="password" inputmode="numeric" autocomplete="off" pattern="[0-9]{4}" maxlength="4" required></label>
        <button class="primary-button" type="submit">Unlock</button>
        <p class="form-message" data-pin-message role="alert"></p>
      </form>
    </div>
  </dialog>`;
}

export function installPinDialog(container: HTMLElement, onUnlocked: () => void | Promise<void>): () => void {
  const dialog = container.querySelector<HTMLDialogElement>('[data-pin-dialog]')!;
  const form = dialog.querySelector<HTMLFormElement>('[data-pin-form]')!;
  const input = form.elements.namedItem('pin') as HTMLInputElement;
  const message = dialog.querySelector<HTMLElement>('[data-pin-message]')!;
  const button = form.querySelector<HTMLButtonElement>('button[type="submit"]')!;

  const close = () => {
    dialog.close();
    form.reset();
    message.textContent = '';
  };
  dialog.querySelector('[data-pin-close]')?.addEventListener('click', close);
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) close();
  });
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    button.disabled = true;
    message.textContent = '';
    try {
      await api('/api/admin/pin', { method: 'POST', body: JSON.stringify({ pin: input.value }) });
      close();
      await onUnlocked();
    } catch (error) {
      message.textContent = error instanceof Error ? error.message : 'The PIN could not be checked.';
      input.select();
    } finally {
      button.disabled = false;
    }
  });

  return () => {
    dialog.showModal();
    input.focus();
  };
}
